import { I18n } from "@similarweb/i18n-provider";
import { SecureShield } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Text, Flex } from "@similarweb/ui-components/foundations";

import { getTermsOfUseHref } from "app/common/hrefs";
import { StyledLink } from "app/components/no-touch-purchase-modal/summary-modal/details/StyledNoTouchPurchaseSummaryModalDetails";
import { StyledLink as ExploreAddonsLink } from "app/components/no-touch-purchase-modal/summary-modal/suggestions/StyledNoTouchPurchaseSummaryModalSuggestions";
import { useNoTouchPurchaseSummaryModalSuggestions } from "app/components/no-touch-purchase-modal/summary-modal/suggestions/useNoTouchPurchaseSummaryModalSuggestions";
import type { INoTouchAddon } from "app/components/no-touch-purchase-modal/summary-modal/useNoTouchPurchaseSummaryModal";
import { NO_TOUCH_PURCHASE_TRANSLATIONS } from "app/components/no-touch-purchase-modal/translations";
import type { AddonTypeName } from "app/contexts/AddonStateContext/const";
import { translate } from "app/filters/i18nFilter";

interface ISmallOneClickFooterProps {
    addonType: AddonTypeName;
    isLoading: boolean;
    selectedAddon?: INoTouchAddon;
    onPurchaseClick: () => void;
}

export const SmallOneClickFooter = ({
    addonType,
    isLoading,
    selectedAddon,
    onPurchaseClick,
}: ISmallOneClickFooterProps) => {
    const { handleLinkClick } = useNoTouchPurchaseSummaryModalSuggestions({
        addonType,
    });

    return (
        <Flex
            flexDirection="column"
            gap="24px"
            padding="24px 24px 12px"
        >
            <Flex
                flexDirection="column"
                gap="4px"
            >
                <Text
                    fontVariant="caption"
                    color={colorsPalettes.carbon[300]}
                    textAlign="center"
                >
                    <I18n
                        i18nKey={NO_TOUCH_PURCHASE_TRANSLATIONS.details.details.paymentMemoSmall}
                        dangerouslySetInnerHTML={true}
                    />
                </Text>
                <Flex
                    gap="4px"
                    width={"100%"}
                >
                    <SecureShield
                        size="xs"
                        color={colorsPalettes.mint[400]}
                    />

                    <Text
                        color={colorsPalettes.carbon[300]}
                        fontVariant="dataTable2"
                        textAlign="center"
                    >
                        {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.details.details.safePayment)}
                        {". "}
                        {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.details.details.youAccept)}{" "}
                        <span data-automation="no-touch-purchase-summary-small-footer-tos-link">
                            <StyledLink
                                target="_blank"
                                isSmallOneClickTest={true}
                                label={translate(NO_TOUCH_PURCHASE_TRANSLATIONS.details.details.tos)}
                                url={getTermsOfUseHref()}
                            />
                        </span>
                    </Text>
                </Flex>
            </Flex>
            <Button
                type="primary"
                isDisabled={!selectedAddon || isLoading}
                onClick={onPurchaseClick}
                width={"100%"}
                data-automation="no-touch-purchase-summary-small-footer-purchase-button"
            >
                {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.details.details.buttonText)}
            </Button>
            <Text
                fontVariant="body2"
                textAlign="center"
            >
                {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.suggestions.bottomText)}{" "}
                <ExploreAddonsLink
                    onClick={handleLinkClick}
                    data-automation="no-touch-purchase-summary-explore-addons-link"
                >
                    {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.suggestions.bottomTextLink)}
                </ExploreAddonsLink>
            </Text>
        </Flex>
    );
};
